import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SimpleHeader from '../components/SimpleHeader.jsx';
import Footer from '../components/Footer.jsx';
import ComprehensiveFAQ from '../components/ComprehensiveFAQ.jsx';

const FAQPage = () => {
  return (
    <div className="min-h-screen">
      <SimpleHeader />
      
      {/* Hero Section for FAQ Page */}
      <section className="hero-section" style={{ minHeight: '40vh', paddingTop: '120px' }}>
        <div className="container">
          <div className="text-center">
            {/* Back to Home Link */}
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 mb-8 text-decoration-none transition-all duration-300 hover:transform hover:translate-x-1"
              style={{ color: 'var(--brand-primary)' }}
            >
              <ArrowLeft size={20} />
              <span className="body-medium font-semibold">Retour à l'accueil</span>
            </Link>
            
            <h1 className="brand-display mb-6" style={{ hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>FAQ</h1>
            <p className="body-large max-w-3xl mx-auto" style={{ color: 'var(--text-on-light)' }}>
              Trouvez toutes les réponses à vos questions sur l'Aïkido, notre dojo, 
              les cours et les modalités d'inscription. Nous sommes là pour vous accompagner 
              dans votre découverte de cet art martial.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Component */}
      <main>
        <ComprehensiveFAQ />
      </main>

      {/* Additional Contact Section */}
      <section className="section-padding section-light">
        <div className="container">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="heading-2 mb-6" style={{ hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>Une question spécifique&nbsp;?</h2>
            <p className="body-medium mb-8" style={{ color: 'var(--text-on-light)' }}>
              Si vous ne trouvez pas la réponse à votre question, n'hésitez pas à nous contacter directement. 
              Nous nous ferons un plaisir de vous renseigner.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/#location" className="btn-primary">
                Nous Rendre Visite
              </Link>
              <Link to="/#pricing" className="btn-secondary">
                Réserver un Essai
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQPage;
